import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-mapeamento", {
        attrs: {
          fim: _vm.mapeamento.fimPerComportComissao,
          inicio: _vm.mapeamento.inicioPerComportComissao,
          acesso: "COMISSAO",
          titulo: "Normalização Comportamental",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.prazoAtual || _vm.prazoEsgotado
                  ? _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(
                          VCol,
                          [
                            _c(
                              VRow,
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  VToolbar,
                                  { attrs: { flat: "" } },
                                  [
                                    _c(VToolbarTitle, [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "title primary--text text--darken-1 text-no-wrap mt-0",
                                        },
                                        [_vm._v(" FILTROS ")]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              VRow,
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(
                                  VCol,
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !_vm.mapeamento.mapeamentoImportado,
                                        expression:
                                          "!mapeamento.mapeamentoImportado",
                                      },
                                    ],
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(VAutocomplete, {
                                      attrs: {
                                        "item-text": _vm.getUnidadeSiglaAndNome,
                                        items: _vm.unidades,
                                        "search-input": _vm.pesquisaUnidades,
                                        label: "Unidade(s):",
                                        placeholder: "Digite para pesquisar...",
                                        multiple: "",
                                        "prepend-icon": "account_balance",
                                        "return-object": "",
                                      },
                                      on: {
                                        "update:searchInput": function (
                                          $event
                                        ) {
                                          _vm.pesquisaUnidades = $event
                                        },
                                        "update:search-input": function (
                                          $event
                                        ) {
                                          _vm.pesquisaUnidades = $event
                                        },
                                        change: function ($event) {
                                          _vm.pesquisaUnidades = ""
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          _vm.unidades.length > 0
                                            ? {
                                                key: "prepend-item",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      VListItem,
                                                      {
                                                        on: {
                                                          click:
                                                            _vm.toggleItens,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          VListItemAction,
                                                          [
                                                            _c(
                                                              VIcon,
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    _vm.filtros
                                                                      .unidades
                                                                      .length >
                                                                    0
                                                                      ? "primary"
                                                                      : "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.icon
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          VListItemContent,
                                                          [
                                                            _c(
                                                              VListItemTitle,
                                                              [
                                                                _vm._v(
                                                                  "Selecionar todas"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(VDivider, {
                                                      staticClass: "mt-2",
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                          {
                                            key: "selection",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  VChip,
                                                  {
                                                    staticClass:
                                                      "chip--select-multi",
                                                    attrs: {
                                                      "input-value":
                                                        data.selected,
                                                      close: "",
                                                      color: "primary",
                                                      small: "",
                                                      "text-color": "white",
                                                    },
                                                    on: {
                                                      "click:close": function (
                                                        $event
                                                      ) {
                                                        return _vm.removeUnidade(
                                                          data.item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          data.item.sigla
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.filtros.unidades,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filtros, "unidades", $$v)
                                        },
                                        expression: "filtros.unidades",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              VRow,
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", sm: "6" } },
                                  [
                                    _c(
                                      VRow,
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(VAutocomplete, {
                                          attrs: {
                                            items: _vm.situacoes,
                                            "item-text": "descricao",
                                            "item-value": "id",
                                            label: "Situação:",
                                            placeholder:
                                              "Digite para pesquisar...",
                                            "prepend-icon": "filter_list",
                                          },
                                          model: {
                                            value: _vm.filtros.situacao,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filtros,
                                                "situacao",
                                                $$v
                                              )
                                            },
                                            expression: "filtros.situacao",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", sm: "6" } },
                                  [
                                    _c(
                                      VRow,
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(VAutocomplete, {
                                          attrs: {
                                            "auto-select-first": true,
                                            disabled:
                                              _vm.filtros.situacao ===
                                              "NAO_ASSOCIADOS",
                                            items: _vm.competenciasFiltro,
                                            "item-text": "nome",
                                            label: "Competência:",
                                            placeholder:
                                              "Digite para pesquisar...",
                                            "prepend-icon":
                                              "format_list_bulleted",
                                            "return-object": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "item",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      VTooltip,
                                                      {
                                                        attrs: {
                                                          "max-width": "500px",
                                                          top: "",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "span",
                                                                    _vm._g(
                                                                      {},
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          data
                                                                            .item
                                                                            .nome
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        data.item.nome ===
                                                        "Todas"
                                                          ? _c("span", [
                                                              _vm._v("Todas"),
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data.item
                                                                    .descricao
                                                                )
                                                              ),
                                                            ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            977840949
                                          ),
                                          model: {
                                            value: _vm.filtros.competencia,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filtros,
                                                "competencia",
                                                $$v
                                              )
                                            },
                                            expression: "filtros.competencia",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              VRow,
                              [
                                _c(
                                  VToolbar,
                                  { attrs: { flat: "" } },
                                  [
                                    _c(VToolbarTitle, [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "title primary--text text--darken-1 text-no-wrap mt-0",
                                        },
                                        [
                                          _vm._v(
                                            " COMPORTAMENTOS (" +
                                              _vm._s(
                                                _vm.comportamentos.length
                                              ) +
                                              ") "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              VRow,
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", md: "4", sm: "6" } },
                                  [
                                    _c("app-sort", {
                                      model: {
                                        value: _vm.opcoes,
                                        callback: function ($$v) {
                                          _vm.opcoes = $$v
                                        },
                                        expression: "opcoes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", md: "4", sm: "6" } },
                                  [
                                    _c("app-search", {
                                      model: {
                                        value: _vm.opcoes,
                                        callback: function ($$v) {
                                          _vm.opcoes = $$v
                                        },
                                        expression: "opcoes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", md: "4", sm: "6" } },
                                  [
                                    _c(
                                      VRow,
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _vm.prazoAtual
                                          ? _c(VAutocomplete, {
                                              attrs: {
                                                "auto-select-first": true,
                                                disabled:
                                                  _vm.selectedComportamentos
                                                    .length === 0,
                                                items:
                                                  _vm.competenciasAssociacao,
                                                dense: "",
                                                "item-text": "nome",
                                                "item-value": "id",
                                                label: "Associar competência:",
                                                placeholder:
                                                  "Digite para pesquisar...",
                                                outlined: "",
                                                "prepend-icon":
                                                  "format_list_bulleted",
                                                "return-object": "",
                                              },
                                              on: { change: _vm.associar },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "item",
                                                    fn: function (data) {
                                                      return [
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: {
                                                              "max-width":
                                                                "500px",
                                                              top: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "span",
                                                                        _vm._g(
                                                                          {},
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              data
                                                                                .item
                                                                                .nome
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            data.item.nome ===
                                                            "Nenhuma..."
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Nenhuma competência comportamental"
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .descricao
                                                                    )
                                                                  ),
                                                                ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4285664466
                                              ),
                                              model: {
                                                value: _vm.competencia,
                                                callback: function ($$v) {
                                                  _vm.competencia = $$v
                                                },
                                                expression: "competencia",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.prazoAtual || _vm.prazoEsgotado
                              ? _c(
                                  VRow,
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      VCol,
                                      [
                                        _c(VDataTable, {
                                          staticClass: "elevation-0",
                                          attrs: {
                                            headers: _vm.headers,
                                            items: _vm.comportamentos,
                                            search: _vm.opcoes.pesquisa,
                                            "sort-by": _vm.opcoes.ordenarPor,
                                            "sort-desc": _vm.opcoes.decrescente,
                                            "custom-filter": _vm.customFilter,
                                            "show-select": _vm.prazoAtual,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: `header.data-table-select`,
                                                fn: function ({ on, props }) {
                                                  return [
                                                    _c(
                                                      VSimpleCheckbox,
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm
                                                                  .comportamentos
                                                                  .length ===
                                                                  0 ||
                                                                _vm.filtros
                                                                  .situacao ===
                                                                  "ORIGINAIS" ||
                                                                _vm.filtros
                                                                  .situacao ===
                                                                  "ARQUIVADOS" ||
                                                                _vm.filtros
                                                                  .situacao ===
                                                                  "CONSOLIDADOS",
                                                              color: "primary",
                                                            },
                                                            on: {
                                                              input:
                                                                _vm.toggleAllCheckboxes,
                                                            },
                                                          },
                                                          "v-simple-checkbox",
                                                          props,
                                                          false
                                                        ),
                                                        on
                                                      )
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.data-table-select`,
                                                fn: function ({
                                                  isSelected,
                                                  select,
                                                  item,
                                                }) {
                                                  return [
                                                    _c(
                                                      VTooltip,
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            item.consolidado ||
                                                            item.excluido ===
                                                              true ||
                                                            _vm.filtros
                                                              .situacao ===
                                                              "ORIGINAIS",
                                                          right: "",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    _vm._g(
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              def: Ripple,
                                                                              name: "ripple",
                                                                              rawName:
                                                                                "v-ripple",
                                                                            },
                                                                          ],
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        VSimpleCheckbox,
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                item.consolidado ||
                                                                                item.excluido ===
                                                                                  true ||
                                                                                _vm
                                                                                  .filtros
                                                                                  .situacao ===
                                                                                  "ORIGINAIS",
                                                                              value:
                                                                                isSelected,
                                                                              color:
                                                                                "primary",
                                                                            },
                                                                          on: {
                                                                            input:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return select(
                                                                                  $event
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "O comportamento não pode ser consolidado antes de ser associado a uma competência"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.comportamento`,
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      VRow,
                                                      {
                                                        attrs: {
                                                          "no-gutters": "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                item.consolidado ||
                                                                !_vm.prazoAtual ||
                                                                item.excluido,
                                                              top: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        _vm._g(
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                display:
                                                                                  "inline-block",
                                                                              },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          !item.consolidado &&
                                                                          _vm.prazoAtual &&
                                                                          !item.excluido
                                                                            ? _c(
                                                                                VEditDialog,
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "save-text":
                                                                                        "Salvar",
                                                                                      "cancel-text":
                                                                                        "Cancelar",
                                                                                      large:
                                                                                        "",
                                                                                      lazy: "",
                                                                                    },
                                                                                  on: {
                                                                                    open: function (
                                                                                      $event
                                                                                    ) {
                                                                                      item.descricaoAtualizada ===
                                                                                        null ||
                                                                                      item.descricaoAtualizada ===
                                                                                        item.descricao
                                                                                        ? (_vm.descricaoNova =
                                                                                            item.descricao)
                                                                                        : (_vm.descricaoNova =
                                                                                            item.descricaoAtualizada)
                                                                                    },
                                                                                    save: function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.editarDescricao(
                                                                                        item
                                                                                      )
                                                                                    },
                                                                                  },
                                                                                  scopedSlots:
                                                                                    _vm._u(
                                                                                      [
                                                                                        {
                                                                                          key: "input",
                                                                                          fn: function () {
                                                                                            return [
                                                                                              _c(
                                                                                                VTextarea,
                                                                                                {
                                                                                                  attrs:
                                                                                                    {
                                                                                                      label:
                                                                                                        "Editar comportamento",
                                                                                                      rows: "3",
                                                                                                    },
                                                                                                  model:
                                                                                                    {
                                                                                                      value:
                                                                                                        _vm.descricaoNova,
                                                                                                      callback:
                                                                                                        function (
                                                                                                          $$v
                                                                                                        ) {
                                                                                                          _vm.descricaoNova =
                                                                                                            typeof $$v ===
                                                                                                            "string"
                                                                                                              ? $$v.trim()
                                                                                                              : $$v
                                                                                                        },
                                                                                                      expression:
                                                                                                        "descricaoNova",
                                                                                                    },
                                                                                                }
                                                                                              ),
                                                                                            ]
                                                                                          },
                                                                                          proxy: true,
                                                                                        },
                                                                                      ],
                                                                                      null,
                                                                                      true
                                                                                    ),
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .filtros
                                                                                          .situacao ===
                                                                                          "ORIGINAIS" ||
                                                                                          (_vm
                                                                                            .filtros
                                                                                            .situacao !==
                                                                                            "ORIGINAIS" &&
                                                                                            item.descricaoAtualizada ===
                                                                                              null)
                                                                                          ? item.descricao
                                                                                          : item.descricaoAtualizada
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                  _c(
                                                                                    VIcon,
                                                                                    _vm._g(
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            color:
                                                                                              "secondary",
                                                                                            small:
                                                                                              "",
                                                                                          },
                                                                                      },
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _vm._v(
                                                                                        " edit "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .filtros
                                                                                          .situacao ===
                                                                                          "ORIGINAIS" ||
                                                                                          (_vm
                                                                                            .filtros
                                                                                            .situacao !==
                                                                                            "ORIGINAIS" &&
                                                                                            item.descricaoAtualizada ===
                                                                                              null)
                                                                                          ? item.descricao
                                                                                          : item.descricaoAtualizada
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique para editar o título do comportamento"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: {
                                                              "max-width":
                                                                "500px",
                                                              top: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VChip,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    item.descricao !==
                                                                                      item.descricaoAtualizada &&
                                                                                    item.descricaoAtualizada !==
                                                                                      null,
                                                                                  expression:
                                                                                    "\n                            item.descricao !== item.descricaoAtualizada &&\n                              item.descricaoAtualizada !== null\n                          ",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "mb-2 ml-2",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "secondary",
                                                                                outlined:
                                                                                  "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            " Editado "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _c(
                                                                "strong",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#9fdfeb",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Comportamento Original:"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.descricao
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VChip,
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  item.consolidado,
                                                                expression:
                                                                  "item.consolidado",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "mb-2 ml-2",
                                                            attrs: {
                                                              color: "success",
                                                              outlined: "",
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Consolidado "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          VChip,
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  item.excluido,
                                                                expression:
                                                                  "item.excluido",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "mb-2 ml-2",
                                                            attrs: {
                                                              color: "error",
                                                              outlined: "",
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Arquivado "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.competencia`,
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              !_vm.prazoAtual,
                                                            expression:
                                                              "!prazoAtual",
                                                          },
                                                        ],
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.competencia
                                                              ? item.competencia
                                                                  .nome
                                                              : "-"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(VSelect, {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: _vm.prazoAtual,
                                                          expression:
                                                            "prazoAtual",
                                                        },
                                                      ],
                                                      attrs: {
                                                        disabled:
                                                          item.consolidado ||
                                                          item.excluido,
                                                        items:
                                                          _vm.competenciasAssociacao,
                                                        "item-text": "nome",
                                                        "item-value": "id",
                                                        label:
                                                          "Selecione uma competência",
                                                        "return-object": "",
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.associarCompetencia(
                                                            item
                                                          )
                                                        },
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "item",
                                                            fn: function (
                                                              data
                                                            ) {
                                                              return [
                                                                _c(
                                                                  VTooltip,
                                                                  {
                                                                    attrs: {
                                                                      "max-width":
                                                                        "500px",
                                                                      top: "",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "activator",
                                                                            fn: function ({
                                                                              on,
                                                                            }) {
                                                                              return [
                                                                                _c(
                                                                                  "span",
                                                                                  _vm._g(
                                                                                    {},
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        data
                                                                                          .item
                                                                                          .nome
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  },
                                                                  [
                                                                    data.item
                                                                      .nome ===
                                                                    "Nenhuma..."
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Nenhuma competência comportamental"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                data
                                                                                  .item
                                                                                  .descricao
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value: item.competencia,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "competencia",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.competencia",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.importancia`,
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              item.consolidado ||
                                                              item.excluido ||
                                                              !_vm.prazoAtual,
                                                            expression:
                                                              "item.consolidado || item.excluido || !prazoAtual",
                                                          },
                                                        ],
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.importancia
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(VTextField, {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            !item.consolidado &&
                                                            !item.excluido &&
                                                            _vm.prazoAtual,
                                                          expression:
                                                            "!item.consolidado && !item.excluido && prazoAtual",
                                                        },
                                                      ],
                                                      attrs: {
                                                        min: 1,
                                                        type: "number",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.atualizarImportancia(
                                                            item
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: item.importancia,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "importancia",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.importancia",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              _vm.prazoAtual
                                                ? {
                                                    key: `item.acoes`,
                                                    fn: function ({ item }) {
                                                      return [
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { left: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    item.descricaoAtualizada !==
                                                                                      null &&
                                                                                    item.descricao !==
                                                                                      item.descricaoAtualizada &&
                                                                                    !item.consolidado,
                                                                                  expression:
                                                                                    "\n                          item.descricaoAtualizada !== null &&\n                            item.descricao !== item.descricaoAtualizada &&\n                            !item.consolidado\n                        ",
                                                                                },
                                                                              ],
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "secondary",
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.restaurarTexto(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "settings_backup_restore"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique para restaurar o texto original do comportamento"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { left: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    !item.excluido &&
                                                                                    !item.consolidado,
                                                                                  expression:
                                                                                    "!item.excluido && !item.consolidado",
                                                                                },
                                                                              ],
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "error",
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  ;(_vm.comportamento =
                                                                                    item),
                                                                                    (_vm.dialogs.removeComportamento = true)
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "archive"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para arquivar o comportamento"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { left: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    item.excluido &&
                                                                                    !item.consolidado,
                                                                                  expression:
                                                                                    "item.excluido && !item.consolidado",
                                                                                },
                                                                              ],
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "error",
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.restaurar(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "settings_backup_restore"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para restaurar o comportamento"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { left: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    !item.excluido &&
                                                                                    item.consolidado,
                                                                                  expression:
                                                                                    "!item.excluido && item.consolidado",
                                                                                },
                                                                              ],
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "success",
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.desconsolidar(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "settings_backup_restore"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para cancelar a consolidação do comportamento"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  }
                                                : null,
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.selectedComportamentos,
                                            callback: function ($$v) {
                                              _vm.selectedComportamentos = $$v
                                            },
                                            expression:
                                              "selectedComportamentos",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  VRow,
                  {
                    staticClass: "justify-end mb-1",
                    attrs: { "no-gutters": "" },
                  },
                  [
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "", "max-width": "400" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      staticClass: "mr-2",
                                      attrs: { color: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.generateWorksheet()
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _c(VIcon, [_vm._v("get_app")]),
                                    _vm._v(" BAIXAR XLS "),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("span", [
                          _vm._v("Clique para baixar os dados em formato XLS."),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(VRow, { attrs: { "no-gutters": "" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.prazoAtual,
                          expression: "prazoAtual",
                        },
                      ],
                      staticClass: "text-lg-right",
                    },
                    [
                      _vm.prazoAtual
                        ? _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            {
                                              attrs: {
                                                disabled:
                                                  !_vm.enableConsolidacao,
                                                color: "primary",
                                              },
                                              on: { click: _vm.consolidar },
                                            },
                                            on
                                          ),
                                          [
                                            _vm._v(" Consolidar "),
                                            _c(
                                              VIcon,
                                              { staticClass: "ml-2" },
                                              [_vm._v(" folder_copy ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3039862448
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Clique no botão para consolidar o(s) comportamento(s) selecionado(s)"
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        VDialog,
        {
          attrs: { "max-width": "370", persistent: "" },
          model: {
            value: _vm.dialogs.removeComportamento,
            callback: function ($$v) {
              _vm.$set(_vm.dialogs, "removeComportamento", $$v)
            },
            expression: "dialogs.removeComportamento",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "headline" }),
              _c(VCardText, [
                _vm._v(" Você realmente deseja arquivar esse comportamento? "),
              ]),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "error", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.arquivar()
                        },
                      },
                    },
                    [_vm._v(" Arquivar ")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "grey", text: "" },
                      on: { click: _vm.toogleRemoveComportamento },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }